// src/utils/initQuestions.js


export async function initQuestions({ userId, email, fullName, themeName,token, isMultiplaySession }) {
  // grab token from Redux


  const resp = await fetch(`${process.env.REACT_APP_BACKEND_URL}/setUserQuestions`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      userId,
      email,
      fullName,
      themeName,
      isMultiplaySession,
    }),
  });

  if (!resp.ok) {
    const err = await resp.json();
    const error = new Error(err.message || 'Failed to initialize questions');
    error.type = err.type; // e.g. 'misconfigured' -- let callers show a specific message
    throw error;
  }
  return resp.json();
}
